var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5664C11.3137 14.5664 14 11.8801 14 8.56641C14 5.2527 11.3137 2.56641 8 2.56641C4.68629 2.56641 2 5.2527 2 8.56641C2 11.8801 4.68629 14.5664 8 14.5664Z",
    stroke: "#929292",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5664C8.41421 12.5664 8.75 12.2306 8.75 11.8164C8.75 11.4022 8.41421 11.0664 8 11.0664C7.58579 11.0664 7.25 11.4022 7.25 11.8164C7.25 12.2306 7.58579 12.5664 8 12.5664Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5669V9.0669C8.34612 9.0669 8.68446 8.96426 8.97225 8.77197C9.26003 8.57967 9.48434 8.30636 9.61679 7.98659C9.74924 7.66682 9.7839 7.31495 9.71637 6.97549C9.64885 6.63602 9.48218 6.3242 9.23744 6.07946C8.9927 5.83472 8.68088 5.66805 8.34141 5.60052C8.00194 5.533 7.65007 5.56765 7.3303 5.70011C7.01053 5.83256 6.73722 6.05686 6.54493 6.34465C6.35264 6.63243 6.25 6.97078 6.25 7.3169",
    stroke: "#929292",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.f5410faa40b3e88bee9955abdc12387e.svg";
export { ForwardRef as ReactComponent };